// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_hr","advertDetailServiceList__header":"c-o_hs","advertDetailServiceList__list":"c-o_ht"};